import angular from 'angular';
import customerDetailsComponent from './customer-details.component';

let customerDetailsModule = angular.module('customerDetails', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('customerDetails', customerDetailsComponent);

export default customerDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/customer-details/customer-details.js